import { BadgeSvg, BlockListSvg, BlockSvg, BriefCase, DashboardSvg, HistorySvg, HomeSvg, InboxSvg, ListSettingSvg, ParticipantSvg, RuleEngineSvg, UserClockSvg, UsersSvg, FileSettingSvg, UsersCogSvg, ReportSearchSvg, DownloadFileSvg, BankCardsSvg, BankCardSvg, CheckFileSvg, AuditSvg } from "../assets/svgs";
import { providerInstitutionConstant } from "./user-constants";

export const MenuMainConstants = {
    home: '/app/home',
    dashboard: '/app/dashboard/home',
    roleParent: '/app/role-management',
    role: '/app/role-management/role-view',
    userParent: '/app/user-management',
    user: '/app/user-management/user',
    participant: '/app/participant-management/viewparticipant',
    ruleEngine: '/app/rule-management/viewrule',
    mccGlobalBlock: '/app/mcc-block-management/globalview',
    mccParticipantBlock: '/app/mcc-block-management/participantview',
    countryBlockParent: '/app/country-block-management',
    countryGlobalBlock: '/app/country-block-management/globalview',
    countryParticipantBlock: '/app/country-block-management/participantview',
    apiConfiguration: '/app/api-configuration-management/apiconfigurationview',
    authenticationHistory: '/app/authentication-history/viewauthenticationhistory',
    reportCatalog: '/app/report-catalog/view-reports',
    cardStatusManagement: '/app/card-status-management/card-registry',  
    cardStatusFileImportLogs: '/app/card-status-management/file-import-logs',
    cardStatusFileImportAuditLogs: '/app/card-status-management/audit-and-reports',
    // acsParams: '/app/acs-params-management/viewacsparams',
    // auditLogs: '/app/audit-log/viewlogs',
};

export const Menus = ({ user }) => {
    const isProvider = (user?.institution?.id === providerInstitutionConstant?.id) && (user?.superAdmin);

    return [
        {
            label: 'Home',
            icon: HomeSvg,
            to: '/app/home',
            subMenus: [
                {
                    label: 'Home',
                    icon: HomeSvg,
                    to: MenuMainConstants?.home,
                }
            ]
        },
        {
            label: 'Dashboard',
            icon: DashboardSvg,
            to: '/app/dashboard',
            subMenus: [
                {
                    label: 'Dashboard Anylatics',
                    icon: DashboardSvg,
                    to: MenuMainConstants?.dashboard,
                }
            ]
        },
        {
            label: 'Role Management',
            icon: BriefCase,
            to: '/app/role-management',
            subMenus: [
                {
                    label: 'Roles',
                    icon: BadgeSvg,
                    to: MenuMainConstants?.role,
                },
                {
                    label: 'Roles Maker Inbox',
                    icon: InboxSvg,
                    to: '/app/role-management/maker-inbox',
                },
                {
                    label: 'Roles Checker Inbox',
                    icon: InboxSvg,
                    to: '/app/role-management/checker-inbox',
                }
            ]
        },
        {
            label: 'User Management',
            icon: UsersCogSvg,
            to: '/app/user-management',
            subMenus: [
                {
                    label: 'Users',
                    icon: UsersSvg,
                    to: MenuMainConstants?.user,
                },
                {
                    label: 'Users Maker Inbox',
                    icon: InboxSvg,
                    to: '/app/user-management/maker-inbox',
                },
                {
                    label: 'Users Checker Inbox',
                    icon: InboxSvg,
                    to: '/app/user-management/checker-inbox',
                }
            ]
        },
        {
            label: 'Participant Management',
            icon: ParticipantSvg,
            to: '/app/participant-management',
            subMenus: [
                {
                    label: 'Participants',
                    icon: UsersSvg,
                    to: MenuMainConstants?.participant,
                },
                {
                    label: 'Participants Maker Inbox',
                    icon: InboxSvg,
                    to: '/app/participant-management/maker-inbox',
                },
                {
                    label: 'Participants Checker Inbox',
                    icon: InboxSvg,
                    to: '/app/participant-management/checker-inbox',
                }
            ]
        },
        {
            label: 'Rule Engine Management',
            icon: RuleEngineSvg,
            to: '/app/rule-management',
            subMenus: [
                {
                    label: 'Rule Engine',
                    icon: ListSettingSvg,
                    to: MenuMainConstants?.ruleEngine,
                },
                {
                    label: 'Rule Engine Maker Inbox',
                    icon: InboxSvg,
                    to: '/app/rule-management/maker-inbox',
                },
                {
                    label: 'Rule Engine Checker Inbox',
                    icon: InboxSvg,
                    to: '/app/rule-management/checker-inbox',
                }
            ]
        },
        {
            label: 'MCC Block Management',
            icon: BlockSvg,
            to: '/app/mcc-block-management',
            subMenus: [
                {
                    label: 'Global MCC Block',
                    icon: BlockListSvg,
                    to: MenuMainConstants?.mccGlobalBlock,
                },
                {
                    label: isProvider ? 'Participant MCC Block' : 'MCC Block',
                    icon: BlockListSvg,
                    to: MenuMainConstants?.mccParticipantBlock,
                },
                {
                    label: 'MCC Block Maker Inbox',
                    icon: InboxSvg,
                    to: '/app/mcc-block-management/maker-inbox',
                }, {
                    label: 'MCC Block Checker Inbox',
                    icon: InboxSvg,
                    to: '/app/mcc-block-management/checker-inbox',
                },
            ]
        },
        {
            label: 'Country Block Management',
            icon: BlockSvg,
            to: '/app/country-block-management',
            subMenus: [
                {
                    label: 'Global Country Block',
                    icon: BlockListSvg,
                    to: MenuMainConstants?.countryGlobalBlock,
                },
                {
                    label: isProvider ? 'Participant Country Block' : 'Country Block',
                    icon: BlockListSvg,
                    to: MenuMainConstants?.countryParticipantBlock,
                },
                {
                    label: 'Country Block Maker Inbox',
                    icon: InboxSvg,
                    to: '/app/country-block-management/maker-inbox',
                }, {
                    label: 'Country Block Checker Inbox',
                    icon: InboxSvg,
                    to: '/app/country-block-management/checker-inbox',
                },
            ]
        },
        {
            label: 'API Configuration Management',
            icon: FileSettingSvg,
            to: '/app/api-configuration-management',
            subMenus: [
                {
                    label: 'API Configuration List',
                    icon: ListSettingSvg,
                    to: MenuMainConstants?.apiConfiguration,
                },
                {
                    label: 'API Configuration Maker Inbox',
                    icon: InboxSvg,
                    to: '/app/api-configuration-management/maker-inbox',
                },
                {
                    label: 'API Configuration Checker Inbox',
                    icon: InboxSvg,
                    to: '/app/api-configuration-management/checker-inbox',
                }
            ]
        },
        // {
        //     label: 'ACS Parameter Management',
        //     icon: SettingsSvg,
        //     to: '/app/acs-params-management',
        //     subMenus: [
        //         {
        //             label: 'ACS Parameters',
        //             icon: ListSettingSvg,
        //             to: '/app/acs-params-management/viewacsparams',
        //         },
        //         {
        //             label: 'ACS Parameters Maker Inbox',
        //             icon: InboxSvg,
        //             to: '/app/acs-params-management/maker-inbox',
        //         },
        //         {
        //             label: 'ACS Parameters Checker Inbox',
        //             icon: InboxSvg,
        //             to: '/app/acs-params-management/checker-inbox',
        //         }
        //     ]
        // },
        {
            label: 'Authentication History',
            icon: UserClockSvg,
            to: '/app/authentication-history',
            subMenus: [
                {
                    label: 'History',
                    icon: HistorySvg,
                    to: MenuMainConstants?.authenticationHistory,
                }
            ]
        },
        {
            label: 'Card Status Management',
            icon: BankCardsSvg,
            to: '/app/card-status-management',
            subMenus: [
                {
                    label: 'Card Registry',
                    icon: BankCardSvg,
                    to: MenuMainConstants?.cardStatusManagement,
                },
                {
                    label: 'File Import Logs',
                    icon: CheckFileSvg,
                    to: MenuMainConstants?.cardStatusFileImportLogs,
                },
                {
                    label: 'Audit Logs',
                    icon: AuditSvg,
                    to: MenuMainConstants?.cardStatusFileImportAuditLogs,
                }
            ]
        },
        {
            label: 'Report Catalog',
            icon: ReportSearchSvg,
            to: '/app/report-catalog',
            subMenus: [
                {
                    label: 'Export Reports',
                    icon: DownloadFileSvg,
                    to: MenuMainConstants?.reportCatalog,
                }
            ]
        },
        // {
        //     label: 'Audit Logs',
        //     icon: AuditSvg,
        //     to: '/app/audit-log',
        //     subMenus: [
        //         {
        //             label: 'Audit Logs',
        //             icon: HistorySvg,
        //             to: '/app/audit-log/viewlogs',
        //         }
        //     ]
        // },
    ]
};